import * as React from 'react';
import { DownloadIcon } from 'lucide-react';
import { ColumnDef } from '@tanstack/react-table';
import type {
  ScheduledProductRestrictionDataImportListEntry as ListEntry,
} from 'contracts/restricted-products/scheduled-data-imports';
import { useAuth } from 'hooks/auth';
import { useDownloadDataImportSourceFile } from 'hooks/api/scheduled-restricted-products-data-imports';
import { Button } from 'components/ui/ButtonGs';
import { DataTableHelper, Formatter } from 'utils';
import { getStatusName, getTypeName } from '../utils';

const dt = new DataTableHelper<ListEntry>({
  enableHiding: false,
  enableSorting: false,
});

export const useScheduledDataImportColumns = (): ColumnDef<ListEntry>[] => {
  const { downloadSourceFile } = useDownloadDataImportSourceFile();
  const { profile } = useAuth();

  const showDownloadButton = React.useMemo(() => {
    if (!profile) return false;
    return profile?.actions?.includes('RES.SCHEDULEDRESDATAIMPORT.DOWNLOAD_SOURCE_FILE');
  }, [profile?.actions]);

  const type = dt.buildColumn({
    id: 'Tipo',
    accessorKey: 'type',
    content: (row) => getTypeName(row.type),
  });
  const user = dt.buildColumn({
    id: 'Usuário',
    content: (row) => row.user.name,
  });
  const startedAt = dt.buildColumn({
    id: 'Iniciado em',
    accessorKey: 'startedAt',
    content: (row) => row.startedAt
      ? Formatter.dateFull(row.startedAt)
      : '--',
  });
  const finishedAt = dt.buildColumn({
    id: 'Finalizado em',
    accessorKey: 'finishedAt',
    content: (row) => row.finishedAt
      ? Formatter.dateFull(row.finishedAt)
      : '--',
  });
  const status = dt.buildColumn({
    id: 'Status',
    accessorKey: 'status',
    content: (row) => getStatusName(row.status),
  });
  const downloadButton = dt.buildColumn({
    id: 'download-button',
    title: '',
    content: (row) => {
      return (
        <div className={'flex justify-end'}>
          <Button.Root
            size={'xs'}
            variant={'primary'}
            className={'pl-2 justify-start'}
            onClick={() => downloadSourceFile(row.id)}
          >
            Arquivo de origem
            <Button.Icon>
              <DownloadIcon className={'w-4 h-4 !fill-current'} />
            </Button.Icon>
          </Button.Root>
        </div>
      );
    },
  });

  return [
    type,
    user,
    startedAt,
    finishedAt,
    status,
    ...(showDownloadButton ? [downloadButton] : []),
  ];
};